import { ref, watch, computed, onMounted } from "@vue/composition-api";
import { formatCurrency } from "@core/utils/filter";
import axiosIns from "@/libs/axios";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useUserLogsList(user_id) {
  // Use toast
  const toast = useToast();

  const refUserLogListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // { key: "id", label: "編號", sortable: true },
    // { key: "project", label: "項目名稱" },
    // { key: "project_id", stickyColumn: true, label: "項目編號", sortable: true },
    { key: "content", label: "主題", sortable: true },
    { key: "changed_data", label: "修改資料", sortable: true },
    // { key: "price", label: "價格", sortable: true, formatter: formatCurrency },
    { key: "create", label: "修改者", sortable: true },
    // { key: "status", label: "狀態" },
    { key: "created_at", label: "創建日期" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const userLogsList = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refUserLogListTable.value
      ? refUserLogListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refUserLogListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery ],
    () => {
      refetchData();
    }
  );
  const userData = ref(null);


  const fetchUserLogs = (ctx, callback) => {
    axiosIns
      .get("user_logs/", {params: {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        user_id: user_id,
        // create_id: user_id,
        log_category_id: 2
      }})
      .then((response) => {
        const { user_logs, total } = response.data;
        callback(user_logs);
        totalRow.value = total;
        userLogsList.value = user_logs
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取個人記錄清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };
 
  const userOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        user: true,
       
      })
      .then((response) => {
      
        userOptions.value = response.data.product_units;   
      });
  };


  onMounted(() => {
  });

  return {
    fetchUserLogs,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    userLogsList,
    refUserLogListTable,
    ability,
    refetchData,
   
  };
}
